import React, { FunctionComponent } from 'react';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@savgroup-front-common/primitive/ui/tooltip';
import { MessageType } from '@savgroup-front-common/types';

interface HeaderProfileRolesProps {
  list: string[];
  message: MessageType;
}

const HeaderProfileRoles: FunctionComponent<
  React.PropsWithChildren<HeaderProfileRolesProps>
> = ({ list, message }) => {
  const [name, ...rest] = list;

  return (
    <p className="truncate text-xs stext-muted-default">
      <SafeFormattedMessageWithoutSpread
        message={message}
        values={{
          bold: (chunks: string) => <strong>{chunks}</strong>,
          tooltip: (chunks: string) => (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="cursor-default underline">{chunks}</span>
                </TooltipTrigger>
                <TooltipContent>{rest.join('\n')}</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ),
          count: rest.length,
          name,
        }}
      />
    </p>
  );
};

HeaderProfileRoles.displayName = 'HeaderProfileRoles';

export default HeaderProfileRoles;
